'use strict';

const Context = require('common/domain/value/context');

class DataContentContext extends Context.ProjectContext {
    constructor(appInfo, user, group, groupRole, project, projectRole, dataContent) {
        super(appInfo, user, group, groupRole, project, projectRole);

        this._context = dataContent;
        this._parentContext = new Context.ProjectContext(appInfo, user, group, groupRole, project, projectRole);
        this._dataContent = dataContent;
    }

    static build(projectContext, dataContent) {
        const appInfo = projectContext.getAppInfo();
        const user = projectContext.getUser();
        const group = projectContext.getGroup();
        const groupRole = projectContext.getGroupRole();
        const project = projectContext.getProject();
        const projectRole = projectContext.getProjectRole();

        return new this(appInfo, user, group, groupRole, project, projectRole, dataContent);
    }

    getDataContent() {
        return this._dataContent;
    }
}

module.exports = DataContentContext;



// WEBPACK FOOTER //
// ./data/domain/value/context.js